//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { Container, Row, Col, ModalFooter, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzDropdown, BzInputText, BzModal, BzModalBody, BzModalHeader } from '../../components';
import { getAlerts, modifyAlert, modifyAlertResponce, setAlert, setAlertsSuccess } from '../../redux/actions/alerts';
import { DISPLAY_EXCHANGE_NAME, LOCATIONS, SET_ALERT_FIELDS, TL_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import config from "../../config.json";
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { useWFHMessages } from '../../hooks';
import { toastConfig } from '../../redux/actions/toast';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import InlineScripSeach from '../Search/InlineScripSeach';
import moment from 'moment';
import { calculateSupportRestistanceValues, convertDateToSeconds, getApiExchangeNameFromMktSegId, getDynamicParamsForToFixed, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, getScripDisplayDescription } from '../../utils/global_functions';
import { useLocation } from 'react-router';
import { resetSearchData } from '../../redux/actions/globalSearch';
import { GetContractDetails, getSecurityDetails } from '../../redux/actions/marketOverview';

const SetAlertModal = () => {
    const dispatch = useDispatch();
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const location = useLocation();
    const objModifyAlertResp = useSelector(state => state?.alerts?.objModifyAlertResp);
    const setAlerResp = useSelector(state => state?.alerts?.setAlerResp);
    const modalData = useSelector(state => state?.modals?.modalData);
    const [bSubmitButtonDisabled, setBSubmitButtonDisabled] = useState(true);
    const modals = useSelector(state => state?.modals?.modals);
    // Parshva S : 26/03/2024 : BT-102679 : Multi Leg Order Entry - Start
    const [isToggleInput, setIsToggleInput] = useState(false);
    const inlineSearchRef = useRef();
    // Parshva S : 26/03/2024 : BT-102679 : Multi Leg Order Entry - End
    const [objAlertInfo, setObjAlertInfo] = useState({
        factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0, pivotPoint: null
    });
    const [objScripData, setObjScripData] = useState({});
    const [pivotPoint, setPivotPoint] = useState([]);
    const [gtcChecked, setGtcChecked] = useState(true);

    const handleClearAlertForm = (e) => {
        e.preventDefault();
        setObjAlertInfo(
            { factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0, pivotPoint: null }

        );
        setGtcChecked(true);
    };


    const handleGtcChange = (data) => {
        setGtcChecked(data);
    };

    useEffect(() => {
        if ((objAlertInfo?.factor2 === 'USE_VALUE' ? (objAlertInfo['amount'])?.toString() : '0')?.length > 0 && objAlertInfo['factor1']?.length > 0 && objAlertInfo['operator']?.length > 0 && objAlertInfo['factor2']?.length > 0 && objScripData['symbol']?.length > 0) {
            setBSubmitButtonDisabled(false);
        } else {
            setBSubmitButtonDisabled(true);
        }
    }, [objAlertInfo, objScripData]);
    const updatScripDataWithTouchLine = (arrTouchLineData) => {
        const nAbsPrevColse = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
        if (arrTouchLineData?.length > 0 && Object.keys(objScripData)?.length) {
            const objScripToBeUpdated = {
                symbol: objScripData?.symbol,
                exchange: objScripData?.exchange,
                series: objScripData?.series,
                description: objScripData?.description,
                token: objScripData?.token,
                mktId: objScripData?.mktId,
                mappedMktId: objScripData?.mappedMktId,
                decimalLocator: objScripData?.decimalLocator,
                last_trade_price: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
                change_in_price: '+' + (nAbsPrevColse),
                change_in_percent: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                exchange_segement: objScripData?.exchange_segement,
                decimalLocator_length: objScripData?.decimalLocator_length,
                expiryDate: objScripData?.expiryDate,
                instrument: objScripData?.instrument,
                high: arrTouchLineData[TL_INDEX.HIGH_PRICE],
                low: arrTouchLineData[TL_INDEX.LOW_PRICE],
                open: arrTouchLineData[TL_INDEX.OPEN_PRICE],
                close: arrTouchLineData[TL_INDEX.CLOSE_PRICE],
            };
            if (nAbsPrevColse > 0) {
                objScripToBeUpdated.change_in_price = nAbsPrevColse.toString();//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing - Start
            } else if (nAbsPrevColse < 0) {
                objScripToBeUpdated.change_in_price = nAbsPrevColse.toString();
            }
            else {
                objScripToBeUpdated.change_in_price = nAbsPrevColse.toString();
            }
            setObjScripData(objScripToBeUpdated);
        }
    };
    useWFHMessages('touchline', (e) => {
        const arrTouchLineData = objScripData && objScripData?.token === e?.detail[TL_INDEX.TOKEN] && objScripData?.mktId === e?.detail[TL_INDEX.SEGMENT_ID] ? e?.detail : [];
        if (arrTouchLineData?.length > 0) {
            updatScripDataWithTouchLine(arrTouchLineData);
        }

    });

    const handleChange = (e) => {
        const inputValue = e.target.value;
        if (objAlertInfo?.factor2 !== 'USE_VALUE') {
            setObjAlertInfo(prev => {
                return { ...prev, amount: 0 };
            });
        } else {
            //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --Start
            const bIsNegativeAllowed = objScripData?.exchange?.toUpperCase() === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT;
            let regex = /^-?(?!.*-)(?!$)(?!.*\s)(?!.*e)(?:[0-8]?\d{0,11}|900000000000)(?:\.\d{0,4})?$/;
            if (!bIsNegativeAllowed) {
                if (objAlertInfo.factor1?.includes('QUANTITY')) {
                    regex = /^(?!.*-)(?!$)(?!.*\s)(?!.*e)(?:[0-8]?\d{0,11}|900000000000)?$/;
                } else {
                    regex = /^(?!.*-)(?!$)(?!.*\s)(?!.*e)(?:[0-8]?\d{0,11}|900000000000)(?:\.\d{0,4})?$/;
                }
                //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --End
            }
            if (e.target.name === 'amount' && regex.test(inputValue) || inputValue === "" || (bIsNegativeAllowed && inputValue === "-")) {
                setObjAlertInfo(prev => {
                    return { ...prev, [e.target.name]: inputValue };
                });
            } else {
            }
        }

        if (e.target.name !== 'amount' && !inputValue?.startsWith(' ')) {
            setObjAlertInfo(prev => {
                return { ...prev, [e.target.name]: inputValue };
            });
        }
    };
    const handlePivotChange = (e) => {
        setObjAlertInfo(prev => {
            return { ...prev, pivotPoint: e.target.value, amount: e.target.value !== "Select" ? e.target.value : prev.amount };
        });
    };
    useEffect(() => {
        if (objModifyAlertResp?.code === 's-101') {
            dispatch(handleModal([{ "SET_ALERT_MODAL": false }]));
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start
            setObjAlertInfo(
                { factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0 }

            );
            setGtcChecked(true);
            setObjScripData({});
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End
            dispatch(modifyAlertResponce({}));
            setTimeout(() => {
                dispatch(getAlerts(objLoginSession?.data?.user_id));
            }, 3000);
            dispatch(toastConfig({ show: true, message: objModifyAlertResp?.message, button: [{ btnName: "ok", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));

        }
        else if (objModifyAlertResp?.code === 'e-101') {
            dispatch(toastConfig({ show: true, message: objModifyAlertResp?.message, button: [{ btnName: "ok", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));
            dispatch(modifyAlertResponce({}));
        } else { }
    }, [objModifyAlertResp, dispatch]);
    useEffect(() => {
        if (setAlerResp?.code === 's-101') {
            dispatch(setAlertsSuccess({}));
            setTimeout(() => {

                dispatch(getAlerts(objLoginSession?.data?.user_id));
            }, 3000);
            modalData?.isShowAlerts && location.pathname !== LOCATIONS.RECOMMENDATIONS ?
                dispatch(toastConfig({ show: true, message: 'Alert Set Successfully', button: [{ btnName: "Close", type: "CLOSE", className: "btn btn-outline-active ms-3" }, { btnName: "View Alerts", type: "VIEV_ALERTS", className: "btn btn-outline-active ms-3" }] })) :
                dispatch(toastConfig({ show: true, message: 'Alert Set Successfully', button: [{ btnName: "ok", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));
            dispatch(handleModal([{ "SET_ALERT_MODAL": false }]));
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start
            setObjAlertInfo(
                { factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0 }

            );
            setGtcChecked(true);
            setObjScripData({});
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End
        } else { }
    }, [setAlerResp, dispatch]);
    useEffect(() => {
        if (typeof modalData?.modifyData == 'object' && Object?.keys(modalData?.modifyData)?.length && typeof modalData?.AlertData == 'object' && Object?.keys(modalData?.AlertData)?.length) {
            setObjAlertInfo({
                factor1: modalData?.modifyData?.factor1, operator: modalData?.modifyData?.operator, factor2: modalData?.modifyData?.factor2, amount: modalData?.modifyData?.amount
            });
            if (modalData?.modifyData?.expiration === 'GTC' || modalData?.modifyData?.expiration === 'GTT') {

                setGtcChecked(true);
            } else {
                setGtcChecked(false);
            }
            setObjScripData({
                symbol: modalData?.AlertData?.symbol,
                exchange: modalData?.AlertData?.exchange,
                series: modalData?.AlertData?.series,
                description: modalData?.AlertData?.description,
                token: modalData?.AlertData?.token,
                mktId: modalData?.AlertData?.mktId,
                mappedMktId: modalData?.AlertData?.mappedMktId,
                decimalLocator: modalData?.AlertData?.decimalLocator,
                decimalLocator_length: modalData?.AlertData?.decimalLocator_length,
                exchange_segement: modalData?.AlertData?.exchange_segement,
                expiryDate: modalData?.AlertData?.expiryDate,
                instrument: modalData?.AlertData?.instrument
            });
        } else if (typeof modalData?.AlertData == 'object' && Object?.keys(modalData?.AlertData)?.length) {
            setObjScripData({
                symbol: modalData?.AlertData?.symbol,
                exchange: modalData?.AlertData?.exchange,
                series: modalData?.AlertData?.series,
                description: modalData?.AlertData?.description,
                token: modalData?.AlertData?.token,
                mktId: modalData?.AlertData?.mktId,
                mappedMktId: modalData?.AlertData?.mappedMktId,
                decimalLocator: modalData?.AlertData?.decimalLocator,
                decimalLocator_length: modalData?.AlertData?.decimalLocator_length,
                exchange_segement: modalData?.AlertData?.exchange_segement,
                expiryDate: modalData?.AlertData?.expiryDate,
                instrument: modalData?.AlertData?.instrument
            });
        } else { }

    }, [modalData]);
    useEffect(() => {
        if (!objScripData?.last_trade_price) {
            sendTouchlineRequest([{ exchangeId: objScripData?.mktId, token: objScripData?.token, isSubscribe: true }]);

            const objLastTickData = dispatch(getWfhTouchlineLastTick());

            const arrScripToBeUpdated = objLastTickData[objScripData?.mktId + '_' + objScripData?.token];
            if (arrScripToBeUpdated?.length > 0) {

                updatScripDataWithTouchLine(arrScripToBeUpdated);
            }
        }
    }, [objScripData]);

    const handleSetAlertSubmit = (e) => {
        e.preventDefault();
        const dateAndTimeOfNow = moment();
        // const dateAndTimeOfToday = moment().endOf('day')?.format("hh:mm A, DD MMM 'YY");

        if (modalData?.isEditable) {
            const payload = {
                UniqueId: modalData?.modifyData?.UniqueId,
                condition: [
                    {
                        operand1: {
                            marketsegment: getMappedMktSegIdFromApiExchangeName(modalData?.modifyData?.ExchangeSegment),
                            token: modalData?.modifyData?.nToken,
                            field: objAlertInfo?.factor1
                        },
                        operand2: {
                            marketsegment: getMappedMktSegIdFromApiExchangeName(modalData?.modifyData?.ExchangeSegment),
                            token: modalData?.modifyData?.nToken,
                            field: objAlertInfo?.factor2,
                            value: objAlertInfo.factor1?.includes('QUANTITY') ? objAlertInfo?.amount : objAlertInfo?.amount * objScripData?.decimalLocator
                        },
                        operator: objAlertInfo?.operator
                    }
                ],
                data: {
                    userid: objLoginSession?.data?.user_id,
                    tenantid: config.TenantId,
                    symbol: modalData?.modifyData?.symbol?.trim(),
                    alertType: objAlertInfo?.factor2,
                    category: modalData?.modifyData?.category === 'EQ' ? 'EQ' : 'FAO'
                },
                expiration: gtcChecked ? 'GTC' : -1, //dateAndTimeOfToday,
                createDate: modalData?.modifyData?.mktIdToken === objScripData?.mktId + '_' + objScripData?.token ? modalData?.modifyData?.createDate : dateAndTimeOfNow,
                serverAlertId: modalData?.modifyData?.serverAlertId,


            };
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start
            // // ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - Start
            // if (payload.condition[0].operand2.value === 0) {
            //     delete payload.condition[0].operand2["value"];
            // }
            // // ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - End
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End
            dispatch(modifyAlert(payload));
        } else {
            const payload = {
                condition: [
                    {
                        operand1: {
                            marketsegment: getMappedMktSegIdFromApiExchangeName(objScripData?.exchange_segement),
                            token: objScripData?.token,
                            field: objAlertInfo?.factor1
                        },
                        operand2: {
                            marketsegment: getMappedMktSegIdFromApiExchangeName(objScripData?.exchange_segement),
                            token: objScripData?.token,
                            field: objAlertInfo?.factor2,
                            value: objAlertInfo.factor1?.includes('QUANTITY') ? objAlertInfo?.amount : objAlertInfo?.amount * objScripData?.decimalLocator
                        },
                        operator: objAlertInfo?.operator
                    }
                ],
                data: {
                    userid: objLoginSession?.data?.user_id,
                    tenantid: config.TenantId,
                    symbol: objScripData?.symbol?.trim(),
                    alertType: objAlertInfo?.factor2,
                    category: objScripData?.instrument === 'EQUITIES' ? 'EQ' : 'FAO'
                    // category: objScripData?.series
                },
                expiration: gtcChecked ? 'GTC' : -1,//dateAndTimeOfToday,
                createDate: dateAndTimeOfNow
            };
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start
            // // ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - Start
            // if (payload.condition[0].operand2.value === 0) {
            //     delete payload.condition[0].operand2["value"];
            // }
            // // ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - End
            //ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End
            dispatch(setAlert(payload));
        }
    };
    const handleSelectScripFromGlobalSearch = (scrip) => {
        setObjScripData({
            symbol: scrip[WATCHLIST_GRID_INDEX.SYMBOL],
            exchange: scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
            series: scrip[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substring(0, 2),
            description: getScripDisplayDescription(scrip),
            token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
            mktId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
            mappedMktId: scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
            decimalLocator: scrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
            decimalLocator_length: getDynamicParamsForToFixed(scrip[WATCHLIST_GRID_INDEX.EXCHANGE]), //By HiralK : 06-09-2023 : For Price optimization
            exchange_segement: getApiExchangeNameFromMktSegId(scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
            expiryDate: scrip[WATCHLIST_GRID_INDEX.EXPIRYDATE],
            instrument: scrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
        });
        setIsToggleInput(false);
        //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --Start
        setObjAlertInfo(
            { factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0 }
        );
        setGtcChecked(true);
        //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --End
    };
    const handleSearchToggle = () => {
        // setObjScripData({});
        setIsToggleInput(true);
    };
    const handleHide = () => {
        setObjScripData({});
        dispatch(handleModalData({ AlertData: {}, modifyData: {}, isEditable: false }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": false }], true));
        dispatch(resetSearchData()); //Shifted from  InlineScripSearch
        setObjAlertInfo(
            { factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0 }
        );
        setGtcChecked(true);
    };
    const handleCancelModal = () => {
        dispatch(handleModal([{ "SET_ALERT_MODAL": false }], true));
        //ManasaB : 07/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start
        setObjAlertInfo(
            { factor1: 'LASTTRADEDPRICE', operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0 }

        );
        setGtcChecked(true);
        setObjScripData({});
        //ManasaB : 07/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End
    };
    // Parshva S : 26/03/2024 : BT-102679 : Multi Leg Order Entry - Start
    useEffect(() => {
        const clickFunction = (event) => {
            if (isToggleInput) {
                if (!inlineSearchRef?.current?.contains(event.target) && !event.target.matches('.inline-search-wrap ,.inline-search-scrip-list, .inline-search-scrip-list *')) {
                    setIsToggleInput(false);
                } else { }
            } else { }
        };
        document.addEventListener('mousedown', clickFunction);
        return () => {
            document.removeEventListener('mousedown', clickFunction);
        };
    }, [isToggleInput]);
    // Parshva S : 26/03/2024 : BT-102679 : Multi Leg Order Entry - End
    //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --Start
    const arrFactor2Fields = useMemo(() => {
        if (objAlertInfo.factor1?.includes('QUANTITY')) {

            setObjAlertInfo((prev) => {
                return { ...prev, operator: '>=', factor2: modalData?.modifyData?.factor2 ?? 'PREVIOUSVOLUME', amount: modalData?.modifyData?.amount ?? 0 };
            });
            return [
                { text: 'Previous Volume', value: 'PREVIOUSVOLUME' },
                { text: 'Use Value', value: 'USE_VALUE' }
            ];
        } else {
            setObjAlertInfo((prev) => {
                return { ...prev, operator: '>=', factor2: 'PREVIOUSCLOSE', amount: 0 };
            });
            return [
                { text: 'Previous Close', value: 'PREVIOUSCLOSE' },
                { text: 'Open Price', value: 'OPENPRICE' },
                { text: 'High', value: 'HIGH' },
                { text: 'Low', value: 'LOW' },
                { text: '52 Week High/Life Time High', value: 'LIFETIMEHIGH' },
                { text: '52 Week Low/Life Time Low', value: 'LIFETIMELOW' },
                { text: 'Use Value', value: 'USE_VALUE' }
            ];
        }
    }, [objAlertInfo.factor1]);

    useEffect(() => {
        let abc = {};
        // {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start */ }
        if (objScripData?.expiryDate) {
            // contract
            abc = dispatch(GetContractDetails({
                "mktSegmentId": objScripData?.mappedMktId ?? objScripData?.mktId,
                "token": objScripData?.token,
                "symbol": objScripData?.symbol,
                "instName": objScripData?.instrument || "FUTCUR",
                "strkPrice": "-1",
                "optType": "",
                "expDate": convertDateToSeconds(objScripData?.expiryDate),
            }));
        } else {
            // security
            abc = dispatch(getSecurityDetails({
                "mktSegmentId": objScripData?.mappedMktId ?? objScripData?.mktId,
                "token": objScripData?.token,
            }));
        }
        // {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- end */ }
        Promise.resolve(abc).then((resp) => {
            const resitancePivotObj = calculateSupportRestistanceValues({
                PrevOpen: resp?.securityData?.pivot[0]?.PrevOpen || resp?.data?.highlowclose?.PrevOpen,
                PrevHigh: resp?.securityData?.pivot[0]?.PrevHigh || resp?.data?.highlowclose?.PrevHigh,
                PrevLow: resp?.securityData?.pivot[0]?.PrevLow || resp?.data?.highlowclose?.PrevLow,
                PrevClose: resp?.securityData?.pivot[0]?.PrevClose || resp?.data?.highlowclose?.PrevClose,
            }, 'Classic', "(H+L+C)/3", getDynamicParamsForToFixed(getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objScripData?.mappedMktId))));
            setPivotPoint([
                { id: "Select", value: null },
                { id: 'S1', value: resitancePivotObj?.supportResistanceInfo?.support?.S1 },
                { id: 'S2', value: resitancePivotObj?.supportResistanceInfo?.support?.S2 },
                { id: 'S3', value: resitancePivotObj?.supportResistanceInfo?.support?.S3 },
                { id: 'Pivot', value: resitancePivotObj?.pivotPoint },
                { id: 'R1', value: resitancePivotObj?.supportResistanceInfo?.resistance?.R1 },
                { id: 'R2', value: resitancePivotObj?.supportResistanceInfo?.resistance?.R2 },
                { id: 'R3', value: resitancePivotObj?.supportResistanceInfo?.resistance?.R3 },
            ]);
        });
    }, [dispatch, objScripData?.token]);

    return (
        <BzModal size="md" show={modals['SET_ALERT_MODAL']} onHide={handleHide} centered>
            <form onSubmit={handleSetAlertSubmit}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>{typeof modalData?.modifyData == 'object' && Object?.keys(modalData?.modifyData)?.length ? 'Modify Alert' : 'Set Alert'}</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={handleCancelModal}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            {isToggleInput || (!modalData?.isEditable && Object.keys(objScripData)?.length <= 0) ?
                                <Col className='mb-3'>
                                    <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} />
                                </Col>
                                :
                                <Col className='d-flex flex-column'>
                                    <div className='d-flex align-items-center mb-1'>
                                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{objScripData?.symbol}</div>
                                        <div className='chips-wrap'>
                                            <div className='exchange-chip me-2'>{objScripData?.exchange}</div>
                                        </div>
                                        <div className='font-regular font-size4 color-subtext text-uppercase me-2'>{objScripData?.description || objScripData?.expiryDate}</div>
                                        {objScripData?.expiryDate ? <div className='font-regular font-size4 color-text text-uppercase me-2'>{objScripData?.instrument?.slice(0, 3)}</div> : null}
                                        {!modalData?.isEditable &&
                                            <Col md={1} className='d-flex justify-content-start align-items-start'>
                                                <div className='icon-16 icon-search icon-dark' onClick={handleSearchToggle}></div>
                                            </Col>
                                        }
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <div className='font-medium font-size4 color-text me-1'>{objScripData?.last_trade_price || 0.00.toFixed(objScripData?.decimalLocator_length)}</div>
                                        <div className={`font-regular font-size4 color-text ${objScripData?.change_in_price?.toString()?.split('')[0] === '-' ? 'color-negative' : 'color-positive'}`}>{objScripData?.change_in_price || 0.00.toFixed(objScripData?.decimalLocator_length)} ({objScripData?.change_in_percent || 0.00.toFixed(2)}%)</div>
                                    </div>
                                </Col>
                            }
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col md={4}>
                                <div className='Bzmodalselect-dropdown'>
                                    <BzDropdown>
                                        <Dropdown.Toggle className='btn-default'>{SET_ALERT_FIELDS.FACTOR1[objAlertInfo.factor1]?.value?.length > 15 ? SET_ALERT_FIELDS.FACTOR1[objAlertInfo.factor1]?.value?.slice(0, 15) + '...' : SET_ALERT_FIELDS.FACTOR1[objAlertInfo.factor1]?.value}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor1', value: 'LASTTRADEDPRICE' } })} value='LASTTRADEDPRICE' >{'Last Traded Price'}</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor1', value: 'BIDPRICE' } })} value='BIDPRICE' >{'Bid Price'}</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor1', value: 'OFFERPRICE' } })} value='OFFERPRICE' >{'Offer Price'}</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor1', value: 'LASTTRADEDQUANTITY' } })} value='LASTTRADEDQUANTITY' >{'Last Traded Quantity'}</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor1', value: 'BIDQUANTITY' } })} value='BIDQUANTITY' >{'Bid Quantity'}</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor1', value: 'OFFERQUANTITY' } })} value='OFFERQUANTITY' >{'Offer Quantity'}</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>
                            </Col>
                            <Col md={3} className='d-flex justify-content-center px-1'>
                                <div className='Bzmodalselect-dropdown'>
                                    <BzDropdown >
                                        <Dropdown.Toggle className='btn-default'>{objAlertInfo?.operator}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'operator', value: '>=' } })} value='>=' >&gt;=</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'operator', value: '<=' } })} value='<=' >&lt;=</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'operator', value: '>' } })} value='>' >&gt;</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'operator', value: '<' } })} value='<' >&lt;</Dropdown.Item>
                                            <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'operator', value: '=' } })} value='=' >=</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>
                            </Col>
                            <Col md={5}>
                                <div className='Bzmodalselect-dropdown'>
                                    <BzDropdown>
                                        <Dropdown.Toggle className='btn-default'>{SET_ALERT_FIELDS.FACTOR2[objAlertInfo.factor2]?.value?.length > 22 ? SET_ALERT_FIELDS.FACTOR2[objAlertInfo.factor2]?.value?.slice(0, 22) + '...' : SET_ALERT_FIELDS.FACTOR2[objAlertInfo.factor2]?.value}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {arrFactor2Fields?.map(field => <Dropdown.Item onClick={handleChange.bind(this, { target: { name: 'factor2', value: field.value } })} value={field.value}>{field.text}</Dropdown.Item>)}
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>
                            </Col>
                        </Row>
                        {objAlertInfo.factor2 === 'USE_VALUE' &&
                            <Row className='g-0 mb-2'>
                                <Col md={4} className='d-flex flex-column justify-content-start'>
                                    <div className='font-regular font-size2 color-subtext mb-1'>{objAlertInfo.factor1?.includes('QUANTITY') ? 'Volume' : 'Amount'} </div>
                                    <BzInputText size='sm' className='font-regular mb-2' type='text' name='amount' onChange={handleChange} value={objAlertInfo.amount} />
                                </Col>
                                {!objAlertInfo.factor1?.includes('QUANTITY') ?
                                    <>
                                        <Col md={3} className='d-flex justify-content-center align-items-center px-1'>
                                            <div className='font-regular font-size2 color-text'>Or</div>
                                        </Col>
                                        <Col md={5} className='d-flex flex-column align-items-start'>
                                            <div className='font-regular font-size2 color-subtext mb-1'>Select Pivot Points</div>
                                            <div className='Bzmodalselect-dropdown w-100'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle className='btn-default'>{objAlertInfo.pivotPoint ? objAlertInfo.pivotPoint : 'Select'}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {pivotPoint?.map((field, i) => (
                                                            <Dropdown.Item key={i} onClick={() => handlePivotChange({ target: { value: field.value, name: 'pivotPoint' } })}>{field.id}{`${field.value != null ? `: ${field.value}` : ''}`}</Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                        </Col>
                                    </>
                                    : null}
                            </Row>
                        }
                        {objAlertInfo.factor2 === 'USE_VALUE' &&
                            <Row className='g-0 pb-2'>
                                <Col className='d-flex align-items-center'>
                                    <input type={'checkbox'} name='gtc' className='form-check-input' onChange={handleGtcChange.bind(this, !gtcChecked)} checked={gtcChecked} />
                                    <label className='form-check-label font-medium font-size2 color-text ms-1 p-t-3'>GTT (Good Till Trigger)</label>
                                </Col>
                            </Row>
                        }
                        {objAlertInfo.factor2 !== 'USE_VALUE' &&
                            <Row className='g-0 pb-2'>
                                <Col className='d-flex align-items-center'>
                                    <input type={'checkbox'} name='gtc' className='form-check-input' onChange={handleGtcChange.bind(this, !gtcChecked)} checked={gtcChecked} />
                                    <label className='form-check-label font-medium font-size2 color-text ms-1 p-t-3'>GTT (Good Till Trigger)</label>
                                </Col>
                            </Row>
                        }
                    </Container>
                </BzModalBody>
                <ModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0 justify-content-end'>
                            <Col md={5} className='d-flex align-items-center'>
                                <BzButton className='btn btn-md btn-block btn-outline me-3' onClick={handleClearAlertForm} type='reset'>Clear</BzButton>
                                <BzButton className='btn btn-md btn-block btn-primary' type='submit' disabled={bSubmitButtonDisabled}>{modalData?.isEditable ? 'Save' : 'Set Alert'}</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </ModalFooter>
            </form>
        </BzModal >
    );
};
export default memo(SetAlertModal);